module.exports = __webpack_public_path__ + "img/stalk.c96be82e.svg";